import SolutionChallengesI18n from "@/components/landing/shared/SolutionChallengesI18n";
import { SearchX, LayoutList, HelpCircle, UserX } from "lucide-react";
const EcommerceChallengesSection = () => <SolutionChallengesI18n translationPrefix="ecommerceSolution" icons={[SearchX, LayoutList, HelpCircle, UserX]} />;
export default EcommerceChallengesSection;
